<template>
    <div v-if="member">
        <v-toolbar :color="null" dense>
            <v-btn icon small @click.stop="$router.go(-1)" title="Back">
                <v-icon>arrow_back</v-icon>
            </v-btn>
        </v-toolbar>
        <v-container>
            <v-layout class="mt-0" justify-center>
                <v-flex xs12 sm8 md6 lg4 xl4>
                    <member :member="member"></member>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import Member from './../components/Member'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Member',
  components: { 'member': Member },
  created () {
    this.setTitle({ title: 'Member' })
  },
  computed: {
    ...mapGetters(
      'member', {
        member: 'selectedMember'
      }
    )
  },
  methods: {
    ...mapActions(
      'application', {
        setTitle: 'setTitle'
      }
    ),
    back () {
      this.$router.go(-1)
    },
    formattedAddress1 (address) {
      let elements = []
      elements.push(address.address1)
      elements.push(address.address2)
      elements.push(address.address3)
      return elements.filter(e => e).join(', ')
    },
    formattedAddress2 (address) {
      let elements = []
      elements.push(address.town)
      elements.push(address.county)
      elements.push(address.post_code)
      return elements.filter(e => e).join(', ')
    },
    googleMapUrl (address) {
      if (address.post_code) {
        return `https://www.google.co.uk/maps/search/${address.post_code.replace(' ', '+')}`
      }
      return null
    }
  }
}
</script>
